<script setup>
import ageDetailModal from '@/components/modal/ageSession/ageDetailModal.vue';
import TotalCount from "@/components/common/totalCount/totalCount.vue";
import AddButton from "@/components/common/button/addButton.vue";
import DeleteButton from "@/components/common/button/deleteButton.vue";
import {computed, onMounted, ref, toRef, watch} from "vue";
import axios from "@/axios";
import AgeInsertModal from "@/components/modal/ageSession/ageInsertModal.vue";
import SearchIconComponent from "@/components/common/button/searchAndResetButton.vue";
import totalCount from "@/components/common/totalCount/totalCount.vue";
import {useAgeStore, useLanguageStore} from "@/pinia";
import {formatDate} from "@/plugins/dayjs";
const languageStore = useLanguageStore();
const ageStore = useAgeStore();

const emits = defineEmits(['set_title'])
const title = computed(() => languageStore.get('meetingCodeManagement'));


const ages = toRef(ageStore.getAges);
const selectAge = ref(ageStore.getRecentAge);
const totalAgeCount = toRef(ageStore.getCountAges);
const selectSession =ref ("");
// modal
const isAgeDetailModal = ref(false);
const age = ref({});
const isAgeInsertModal = ref (false);
const sc_age = ref("");
const sc_ages = ref([]);
const isSearch =ref(false);


const set_isAgeDetailModal = (age)=>{
  isAgeDetailModal.value = age;
}
const set_IsAgeInsertModal = (is)=>{
  isAgeInsertModal.value = is ;
}
const set_selectAge= (age)=>{
  selectAge.value= age
}
const set_selectSession = (session)=>{
  selectSession.value = session;
}
const fn_ModifyAge = (data)=>{
  ageStore.updateAge(data);
}
const fn_saveAge = (newAge)=>{
  ageStore.insertAge(newAge)
}
const fn_ageDoubleClick = ()=>{
  const selected = selectAge.value;
  age.value = ages.value.find(a=> a.ageId === selected)
  isAgeDetailModal.value =true
}
const fn_deleteAge = ()=>{
  ageStore.deleteAge(selectAge.value)
}

const fn_search = ()=>{
  selectAge.value =""
  selectSession.value =""
  if (sc_age.value== '') {
    totalAgeCount.value = ages.value.length;
    isSearch.value = false;
    return
  }
  sc_ages.value = ages.value.filter(a => a.ageTitle.includes(sc_age.value));
  totalAgeCount.value = sc_ages.value.length;
  console.log(sc_ages.value.length);
  isSearch.value = true;
}
const fn_reset = ()=>{
  selectAge.value =""
  selectSession.value =""
  sc_age.value = "";
  totalAgeCount.value = ages.value.length;
  isSearch.value = false;
}

onMounted(()=>{
  emits('set_title', title.value)
})
watch(title, (v) => emits('set_title', v))
</script>

<template>

  <div class="searchArea">
    <v-text-field
        class="search-field"
        v-model="sc_age"
        @keydown.enter="fn_search"
        hide-details
        variant="outlined"
        density="compact"
        :label="languageStore.get('number')"
    ></v-text-field>
    <search-icon-component
        @fn_search="fn_search"
        @fn_reset="fn_reset"
    ></search-icon-component>
  </div>
  <div class="ageSessionArea">
    <div class="ageArea">
      <div class="ageTopArea">
        <total-count :total-count="totalAgeCount" class="totalCount"></total-count>
        <div class="subTitle"> {{languageStore.get('number')}} </div>
        <div class="addDeleteButtonArea">
          <add-button @click="set_IsAgeInsertModal(true)"></add-button>
          <delete-button @click="fn_deleteAge"></delete-button>
        </div>
      </div>

      <div class="ageMainArea">
        <template v-if="(isSearch ? sc_ages : ages).length === 0">
          <div class="notData">
            <v-icon size="36" color="#B0BEC5">mdi-database-off-outline</v-icon>
            <p>{{languageStore.get('noData')}}</p>
          </div>
        </template>
        <template v-for="(age,i) in isSearch ?sc_ages :ages" :key="i">
          <div class="ageContent" :class="{ selectedAgeContent: selectAge === age.ageId }" @click="set_selectAge(age.ageId)" @dblclick="fn_ageDoubleClick" >
            <div class="ageTitleArea">
              {{age.ageTitle}}
            </div>
            <div class="ageDtArea" v-if="age.startDt != null || age.endDt != null">
              <div>
                {{formatDate(age.startDt, 'YYYY-MM-DD')}}
              </div>
              &nbsp; ~ &nbsp;
              <div>
                {{formatDate(age.endDt, 'YYYY-MM-DD')}}
              </div>
            </div>
          </div>
        </template>
      </div>
    </div>
    <!--
    <div class="sessionArea" >
      <div class="sessionTopArea">
        <div></div>
        <div class="subTitle"> {{languageStore.get('session')}} </div>
        <div class="addDeleteButtonArea">
          <add-button></add-button>
          <delete-button></delete-button>
        </div>
      </div>
      <div class="sessionMainArea">
        <template v-for="(age,i) in ages" :key="i">
          <template v-if="selectAge== age.ageId">
            <template v-if="age.sessionResponse.length >0">
              <template v-for="(session,i) in age.sessionResponse" :key="i">
                <div class="ageContent"  :class="{selectedAgeContent: selectSession === session.sessionId}"  @click ="set_selectSession(session.sessionId)">
                  {{session.sessionTitle}}
                </div>
              </template>
            </template>
            <template v-else>
              <div class="notData">
                {{languageStore.get('noData')}}
              </div>
            </template>
          </template>
        </template>
      </div>
    </div>
    -->
  </div>

  <age-insert-modal
    :is-age-insert-modal ="isAgeInsertModal"
    @set_IsAgeInsertModal = "set_IsAgeInsertModal"
    @fn_saveAge = "fn_saveAge"
  ></age-insert-modal>
  <ageDetailModal
      :age="age"
      :isAgeDetailModal="isAgeDetailModal"
      @set_isAgeDetailModal="set_isAgeDetailModal"
      @fn_ModifyAge="fn_ModifyAge"
  >
  </ageDetailModal>
</template>

<style scoped>
.ageSessionArea{
   display: flex;
   width: 90vw;
   justify-content: center;
   align-items: center;
   height: 70vh;

 }
.searchArea{
  background: white;
  position: relative;
  width: 50vw;
  height: 8vh;
  margin: 10px 0 10px 0;
  padding: 0 20px;
  border-radius: 30px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 12px;
}
.search-field {
  min-width: 150px;
  max-width: 200px;
}
.searchOne{
  width: 400px;
}
.addDeleteButtonArea{
  display: flex;
}
.ageTitleArea{
  font-weight: bolder;
}
/*
.ageArea{
  background: white;
  width: 30vw;
  height: 90%;
  border-radius: 10px;
}
 */
.ageArea{
  background: white;
  width: 50vw;
  height: 90%;
  border-radius: 10px;
}
.ageTopArea{
  display: flex;
  align-items: center;
  height: 15%;
  justify-content: space-between;
  border-bottom: 1px solid #AFAFAF;
  padding: 10px
}
.ageMainArea{
  height: 90%;
  overflow-y: scroll;
}
.ageContent{
  height: 6vh;
  display: flex;
  font-size: 1.2rem;
  align-items: center;
  justify-content: center;
  border-bottom: 1px solid #C7C7C7;
  cursor: pointer;
  flex-direction: column;
}
.selectedAgeContent{
  height: 6vh;
  display: flex;
  font-size: 1.2rem;
  align-items: center;
  justify-content: center;
  border-bottom: 1px solid #C7C7C7;
  background-color: #052C65;
  color:white;
}
.subTitle{
  margin-left: 100px;
  font-size: 1.5rem;
  font-weight: bold;
}
.totalCount{
  position: relative;
  bottom: 20px;
}
.sessionArea{
  margin-left: 50px;
  background: white;
  width: 30vw;
  height: 90%;
  border-radius: 10px;
}
.sessionTopArea{
  display: flex;
  align-items: center;
  height: 15%;
  justify-content: space-between;
  border-bottom: 1px solid #AFAFAF;
  padding: 10px
}
.ageDtArea{
  font-size: 0.9rem;
  display: flex;
}
.notData{
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: #90A4AE;
  padding: 40px 20px;
  font-size: 14px;
  gap: 8px;
}
</style>